import {
  SearchParameterKeysTypeEnum,
  SearchParameterTypeEnum,
} from '@lib/enums/search.enum'

export const clearUserSearchParams = (get: any, set: any) => {
  const sp = get().searchParameters
  const current = get().currentUserSearchParameters

  clearSearchParameters(sp)
  const filteredCurrentParams = clearCurrentUserSearchParameters(current)

  set({
    currentUserSearchParameters: filteredCurrentParams,
    searchParameters: sp,
    searchDateRange: {
      startDate: null,
      endDate: null,
    },
  })
}

const clearSearchParameters = (sp) => {
  return Object.keys(sp).forEach((key) => {
    if (key === SearchParameterKeysTypeEnum.SEARCH_TEXT) return

    if (Array.isArray(sp[key]?.values)) {
      const type = sp[key].type
      sp[key].values = sp[key].values.map((v, i) => ({
        ...v,
        selected: type === SearchParameterTypeEnum.SWITCH ? i === 0 : false,
      }))
    }
  })
}

const clearCurrentUserSearchParameters = (currentUserSearchParameters) => {
  return currentUserSearchParameters.filter(
    (param) => Object.keys(param)[0] === SearchParameterKeysTypeEnum.SEARCH_TEXT
  )
}
